import { createReducer, on } from '@ngrx/store';
import { addToHistory, clearHistory } from './history.actions';

export interface HistoryState {
  pageHistory: string[];
  currentPage: string | null;
}

export const initialHistoryState: HistoryState = {
  pageHistory: [],
  currentPage: null
};

export const historyReducer = createReducer(
  initialHistoryState,
  on(addToHistory, (state, { page }) => {

    return {
      ...state,
      pageHistory: [...state.pageHistory, page],
      currentPage: page
    };
  }),
  on(clearHistory, (state) => state)
);
